import { lorem, parseHex, gri, shi, overall, blues, formatValue, bivariateColor, getWidth, parseColor } from "./Utils";
import { LIGHT_GRAY, MIN_YEAR, MAX_YEAR, HIGHLIGHT_COLOR, DEFAULT_COLOR, MOBILE_WIDTH, DPR} from "./Constants";

class Animation {
	constructor(graphic, step, zoom, layout, slice, velocity, center, reverse, offset_x, offset_y, min_year, max_year, order, reposition, image, caption) {
		this.graphic = graphic;
		this.step = step;
		this.zoom = typeof zoom == "undefined" ? this.graphic.baseScale : parseFloat(zoom);
		this.init_zoom = parseFloat(this.graphic.layoutManager.zoomLevel || 1);
		this.init_labelFactor = parseFloat(this.graphic.layoutManager.labelFactor || 1);
		this.min_year = typeof min_year == "undefined" ? MIN_YEAR : parseInt(min_year);
		this.max_year = typeof max_year == "undefined" ? MAX_YEAR : parseInt(max_year);
		this.order = typeof order == "undefined" ? undefined : JSON.parse(order);
		this.layout = layout;
		this.slice = slice;
		this.velocity = this.layout == 'scatter' ? 0 : velocity;
		this.center = center;
		this.reverse = reverse;
		this.offset_x = offset_x;
		this.offset_y = offset_y;
		this.reposition = reposition;
		this.image = image;
		this.caption = caption;
		this.centroid = null;
	}
	man() {
		return this.graphic.layoutManager;
	}

	scatterCentroid(){
		this.centroid = this.man().getCentroid(this.center, true, true, "shi_25");
		this.offset_x = this.centroid[0] - this.man().container.x;
		this.offset_y = this.centroid[1] - this.man().container.y;
	}

	prepare(resize_labels, resize) { 
		this.graphic.labelsOff();
		this.graphic.tooltipOff();

		if (this.layout == 'demo') {
			this.man().resetColor(LIGHT_GRAY);
			if (this.reverse) {
				this.man().isolateCountry(this.center);
			} else {
				this.man().pulse(this.center, '#f2f2f2', '#f2f2f2', 1, 0, true);
			}

			this.man().layout("shi", this.slice, this.center, this.offset_x, this.offset_y);
			if (resize_labels) this.man().resizeLabels(this.man().labelFactor);
			this.man().countryColor(this.center, bivariateColor(this.graphic.model.getGRI(this.center), this.graphic.model.getSHI(this.center)));
		} else if( this.layout != 'scatter' ){
			this.man().layout(this.layout, this.slice, this.center, this.offset_x, this.offset_y, this.min_year, this.max_year, this.order);
			if (resize_labels) this.man().resizeLabels(this.man().labelFactor);
		}

		if(~[2, 3].indexOf(this.step)){
			this.man().resetColor();
			this.man().countryColor("840", HIGHLIGHT_COLOR)
		}

		if(this.step == 80  && this.reverse) {
			this.man().resetColor();
		}

		if (this.step == 5 && !this.reverse) {
			this.man().isolateCountry("840");
			this.man().countryColor("840", LIGHT_GRAY);
			this.man().layout(this.layout, this.slice, this.center, this.offset_x, this.offset_y, this.min_year, this.max_year, undefined);
			this.man().updateLabels(this.order, "order");
			if (resize_labels) this.man().resizeLabels(this.man().labelFactor);
		} else if (~["score", "shi", "gri"].indexOf(this.layout)) {
			if (typeof this.order == 'undefined') {
				this.man().resetColor(LIGHT_GRAY);
			}
			this.man().score_tint(this.layout, this.velocity);
		}

		// calculate the centroid again, with the new offset this time
		if(typeof this.center == "undefined") {
			this.centroid = this.graphic.center();
		} else if (~["demo", "scatter"].indexOf(this.layout) ) {
			//this.centroid = this.man().getCentroid(this.center, true, true, "shi_25");

		} else if (this.layout == "map") {
			this.man().resetColor(LIGHT_GRAY);
			this.centroid = this.man().getCentroid(this.center, false, true);
			if (this.step == 99) {
				this.graphic.selectedCountry = undefined;
				this.graphic.dropdown.dropdown('restore default text');
				this.graphic.dropdown[0].removeAttribute('data-iso');
				this.man()._zoomLevel = undefined;
				this.man().resetColor(LIGHT_GRAY);
				this.graphic._labels1.replaceChildren();
			}
		} else {
			this.centroid = this.man().getCentroid(this.center, true, true);
		}


		if ( this.step == 1 ) {
			this.man().regionColor();
			this.man().resetScaleAll();
			this.graphic.spares_container.renderable = false;
		}
		
		if ( this.step == 98 ){
			this.graphic.selectedCountry = undefined;
			this.graphic.buttons.classList.remove('active');
			this.graphic.handleDropdown("", undefined, undefined);
			this.graphic.dropdown_icon.classList.remove('clear');
		}

		if ( this.layout == 'global_scatter' ) {
			this.man().regionColor();
			if (this.step > 95) {
				this.man().setAlpha(0);
				this.man().setAlphaFirst(1);
			}
			if ( this.step == 96 ) {
				this.man().setAlphaFirst(.07);
				this.man().setAlphaFirst(1, '376');
				this.man().setAlphaFirst(1, '760');
				this.man().setAlphaFirst(1, '586');
			}
		}
		return new Promise( (resolve, reject) => resolve('prepare'));
	}


	animate(resize_labels=true, resize=false) {	
		return this.prepare(resize_labels, resize)
			.then(()=> this.transition(resize_labels, resize));
	}

	transition(resize_labels=true, resize=false) {
		if (this.layout == "scatter") {
			if (~["scatter", "global_scatter"].indexOf(this.man().current)){
				this.man().layout(this.layout, this.slice, this.center, this.offset_x, this.offset_y, this.min_year, this.max_year, this.order);
			}
			if (resize) this.man().layout(this.layout, this.slice, this.center, this.offset_x, this.offset_y, this.min_year, this.max_year, this.order);
			if (resize_labels) this.man().resizeLabels(this.man().labelFactor);
			this.man().isolateCountry(this.center);
			this.handleAxisDim();

		} else {
			this.man().zoomTo(this.man().zoomLevel, this.zoom, this.man()._center[0], this.man()._center[1], this.centroid[0], this.centroid[1], this.velocity, this.offset_x, this.offset_y, () => {
				this.man().zoomLevel = this.zoom;
				this.man()._center = this.centroid;
				this.graphic.labelsOn();
				
				if (this.step == 99) this.graphic.dropdown.dropdown('restore default value');
				if (this.layout == 'demo') {
					this.man().layout(this.layout, this.slice, this.center, this.offset_x, this.offset_y);
					if (resize_labels) this.man().resizeLabels(this.man().labelFactor);
				} else if (~[5].indexOf(this.step) && !this.reverse) {
					this.man().resetColor(LIGHT_GRAY);
					for (let i=0; i < this.order.length; i++ ){
						if (this.order[i] != null ){
						this.man().countryColor(this.order[i], bivariateColor(this.graphic.model.getGRI(this.order[i]), this.graphic.model.getSHI(this.order[i])));
						}
					}
					this.man().zoomTo(this.man().zoomLevel, this.zoom, this.man()._center[0], this.man()._center[1], this.centroid[0], this.centroid[1], 4, this.offset_x, this.offset_y, () => {
							this.man().zoomTo(this.man().zoomLevel, this.zoom, this.man()._center[0], this.man()._center[1], this.centroid[0], this.centroid[1], 4, this.offset_x, this.offset_y, () => {
						this.man().isolateCountry(this.order);
						this.man().zoomTo(this.man().zoomLevel, this.zoom, this.man()._center[0], this.man()._center[1], this.centroid[0], this.centroid[1], 5, this.offset_x, this.offset_y, () => {
							this.man().layout(this.layout, this.slice, this.center, this.offset_x, this.offset_y, this.min_year, this.max_year, this.order);
							if (resize_labels) this.man().resizeLabels(this.man().labelFactor);
						});
					});
				});
				}
				this.handleAxisDim();
			});
		}
	}
	handleReposition() {
		// this messes up the label replacement -- maybe return to this
		// at the very least when layout == demo and reposition == true correct label positioning
		// recalculate the offset
		if (this.reposition) {
			if (this.layout == "map") {
				this.centroid = this.man().getCentroid(this.center, false, false, "map_Infinity");
			} else {
				this.centroid = this.man().getCentroid(this.center, true, false, "shi_25");
			}
			this.offset_x = this.man()._center[0] - this.centroid[0];
			this.offset_y = this.man()._center[1] - this.centroid[1];
		}
	}
	handleAxisDim() {
		if (this.step == 96){
			let labels = document.querySelectorAll('.index-label.global_scatter');
			for (let i =0; i < labels.length; i++){
				labels[i].classList.add('active');
			}
		} else {
			let labels = document.querySelectorAll('.index-label.global_scatter');
			for (let i =0; i < labels.length; i++){
				labels[i].classList.remove('active');
			}
		}
	}
	handleImage() {
		if (typeof this.image !== 'undefined' && this.graphic.width > MOBILE_WIDTH ){
			if (this.graphic.imagePane.style.backgroundImage != 'none') {
				this.graphic.imagePane.classList.remove('active');
				setTimeout( () => {
					this.graphic.imagePane.style.backgroundImage = `url('${this.image}')`;
					this.graphic.imagePane.classList.add('active');
				}, 500);
			} else {
				this.graphic.imagePane.style.backgroundImage = `url('${this.image}')`;
				this.graphic.imagePane.classList.add('active');
			}
		} else {
			this.graphic.imagePane.classList.remove('active');
			setTimeout( () => this.graphic.imagePane.style.backgroundImage = `none`, 500);
		}
	}
}
export default Animation;
